<template>
    <div class="header">
        <div class="header-main-container">
            <router-link to="/"><img class="logo-img" src="../../assets/images/logo.png" alt="" /></router-link>
            <div class="router-menu-bar-container">
                <el-menu
                    class="router-menu"
                    mode="horizontal"
                    :default-active="defaultRouterComputed"
                    router
                >
                    <el-menu-item index="/">伦伟首页</el-menu-item>
                    <el-menu-item index="/product-services"
                        >产品与服务</el-menu-item
                    >
                    <el-menu-item index="/successful-cases"
                        >成功案例</el-menu-item
                    >
                    <el-menu-item index="/consult">咨询购买</el-menu-item>
                    <el-menu-item index="/news">新闻资讯</el-menu-item>
                    <el-menu-item index="/aboutUs">关于我们</el-menu-item>
                    <el-menu-item index="/joinUs">加入我们</el-menu-item>
                </el-menu>
                <div class="phone-container">
                    <img
                        class="phone-img"
                        src="../../assets/images/phone.png"
                        alt=""
                    />
                    <span class="phone-text">4008-835-538</span>
                </div>
            </div>
            <div class="mobile-router-menu-container">
                <el-dropdown class="head-menu-dropdown" trigger="click">
                    <img
                        class="mobile-menu-img"
                        src="../../assets/images/menu-img.png"
                        alt=""
                    />
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <router-link to="/"> 伦伟首页 </router-link>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link to="/product-services"
                                >产品与服务</router-link
                            >
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link to="/successful-cases"
                                >成功案例</router-link
                            >
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link to="/consult">咨询购买</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link to="/news">新闻资讯</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <router-link to="/aboutUs">关于我们</router-link>
                        </el-dropdown-item>
                         <el-dropdown-item>
                            <router-link to="/joinUs">加入我们</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item disabled>
                            <div class="mobile-menu-phone-container">
                                <img
                                    class="mobile-menu-phone-img"
                                    src="../../assets/images/phone.png"
                                    alt=""
                                />
                                <span class="phone-text">4008-835-538</span>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import { ROUTERINFOMAP } from "../../utils/constant";

export default {
    name: "TopBanner",
    computed: {
        defaultRouterComputed: function () {
            const routeName = this.$route.name;
            return ROUTERINFOMAP.get(routeName);
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/Layout/TopBanner.scss";
</style>
